export function mergeTranslations(translations) {
    if (!Array.isArray(translations))
        throw "!Array.isArray(translations)";
    if (translations.length == 0)
        return null;
    if (translations.length == 1)
        return translations[0];

    var merge = Object.assign({}, ...translations);
    return merge;
}